import type { QuoteHelpers } from './types';

export function useQuoteHelpers(): QuoteHelpers {
  const getQuoteProductVariantAttributeValueByExternalId = (
    quoteLine: any,
    externalId: string
  ): any =>
    quoteLine.productVariant?.attributeValuesVariant?.find(
      (attr: any) => attr.attribute.externalId === externalId
    )?.value['fr-FR'];
  return {
    getQuoteProductVariantAttributeValueByExternalId,
  };
}
